import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
// gsap wordt dynamisch geladen (zie loadGsap) zodat het niet in de
// gedeelde entry-bundel terechtkomt.

async function loadGsap() {
  const [{ gsap }, { ScrollTrigger }] = await Promise.all([
    import("gsap"),
    import("gsap/ScrollTrigger"),
  ]);
  gsap.registerPlugin(ScrollTrigger);
  return gsap;
}
// Lazy: houdt recharts (~141 KiB) uit de audit-route chunk zodat een
// intent-preload van /audit vanuit de Nav de bibliotheek niet meesleept.
const AuditTrafficChart = lazy(() =>
  import("../components/proof-charts").then((m) => ({ default: m.AuditTrafficChart })),
);
import { pageHead, auditServiceJsonLdScript } from "@/lib/seo";

const TITLE = "SEO, GEO & AI-analyse — €995 | IT Solutions";
const DESC =
  "Diepgaande audit (30–50 pagina's) voor vindbaarheid in Google én AI-agents zoals ChatGPT, Perplexity, Copilot en Grok. Vaste prijs: €995.";

import { AuditPage } from "@/pages/audit";

export const Route = createFileRoute("/audit")({
  head: () => {
    const head = pageHead({
      lang: "nl",
      pathWithoutLang: "/audit",
      title: TITLE,
      description: DESC,
    });
    return {
      ...head,
      scripts: [auditServiceJsonLdScript("nl")],
    };
  },
  component: AuditPage,
});
